import { useLang } from "@/lib/i18n";
import { IMAGES } from "@/lib/api";

const ExcursionCard = ({ id, label, name, lead, points, option, img, onChoose, chooseLabel, reverse }) => (
  <article className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center ${reverse ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`excursion-${id}`}>
    <div className="overflow-hidden gold-frame p-3 group">
      <img src={img} alt={name} className="w-full aspect-[5/4] object-cover transition-transform duration-[1500ms] group-hover:scale-110" />
    </div>
    <div>
      <p className="text-[#D4AF37] tracking-[0.3em] text-xs uppercase mb-3">{label}</p>
      <h3 className="font-display text-4xl sm:text-5xl mb-4">{name}</h3>
      <p className="text-slate-200 text-lg mb-6">{lead}</p>
      <ul className="space-y-4 mb-8 text-slate-300">
        {points.map(([title, text]) => (
          <li key={title} className="flex gap-3"><span className="text-[#D4AF37]">—</span>
            <span><strong className="text-white font-medium">{title} :</strong> {text}</span></li>
        ))}
      </ul>
      <div className="gold-frame px-5 py-4 mb-10 text-[#D4AF37] tracking-wide" data-testid={`excursion-${id}-option`}>{option}</div>
      <button onClick={() => onChoose(id)} data-testid={`choose-${id}-btn`}
        className="border border-[#D4AF37] text-[#D4AF37] px-7 py-3.5 tracking-wider hover:bg-[#D4AF37] hover:text-[#050B14] transition-colors duration-300">
        {chooseLabel}
      </button>
    </div>
  </article>
);

export default function Excursions({ onChoose }) {
  const { t } = useLang();
  return (
    <section id="excursions" className="scroll-mt-20 bg-[#0A1325] border-y border-white/5 py-24 sm:py-32" data-testid="excursions-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-10">
        <p className="text-[#D4AF37] tracking-[0.3em] text-xs uppercase mb-4">{t.exc_kicker}</p>
        <h2 className="font-display text-4xl sm:text-6xl mb-20 max-w-2xl">{t.exc_title}</h2>
        <div className="space-y-28">
          <ExcursionCard id="classic" label={t.exc1_label} name={t.exc1_name} lead={t.exc1_lead} points={t.exc1_points}
            option={t.exc1_option} img={IMAGES.classic} onChoose={onChoose} chooseLabel={t.choose} />
          <ExcursionCard id="sunset" label={t.exc2_label} name={t.exc2_name} lead={t.exc2_lead} points={t.exc2_points}
            option={t.exc2_option} img={IMAGES.sunset} onChoose={onChoose} chooseLabel={t.choose} reverse />
        </div>
      </div>
    </section>
  );
}
